import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StatCard = _ref => {
  let {
    statValue,
    secondaryStatValue,
    statName,
    isValueLoading
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: "bg-grey-50 p-4 sm:p-6 rounded-2xl flex flex-col justify-between w-full",
    children: [isValueLoading ? /*#__PURE__*/_jsx("div", {
      className: "w-[80%] rounded text-5 sm:h-9 mb-4 bg-grey-200 animate-pulse"
    }) : /*#__PURE__*/_jsxs("div", {
      className: "pb-4",
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-xl sm:text-3xl font-mono prose tracking-tighter",
        children: statValue
      }), !!(secondaryStatValue !== null && secondaryStatValue !== void 0 && secondaryStatValue.length) && /*#__PURE__*/_jsx("p", {
        className: "text-sm font-mono font-medium prose tracking-tighter",
        children: secondaryStatValue
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "text-sm text-grey-400 font-bold max-w-[20ch]",
      children: statName
    })]
  });
};